<script setup>
import Modal from './Modal.vue'

const emit = defineEmits(['close'])

defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    maxWidth: {
        type: String,
        default: '2xl',
    },
    closeable: {
        type: Boolean,
        default: true,
    },
})

const close = () => {
    emit('close')
}
</script>

<template>
    <Modal
        :show="show"
        :max-width="maxWidth"
        :closeable="closeable"
        @close="close"
    >
        <div class="absolute top-1 right-1">
            <slot name="close" />
        </div>

        <div class="px-6 py-4">
            <div class="text-center text-2xl font-medium text-gray-900 dark:text-gray-100">
                <slot name="title" />
            </div>

            <div class="mt-4 text-center text-sm text-gray-600 dark:text-gray-400">
                <slot name="subtitle" />
            </div>

            <div class="mx-auto mt-4 flex flex-col items-center justify-center text-center text-sm text-gray-600 dark:text-gray-400">
                <slot name="content" />
            </div>
        </div>

        <div class="relative z-20 flex flex-row justify-end bg-gray-100 px-6 py-4 text-end dark:bg-zinc-900">
            <slot name="footer" />
        </div>
    </Modal>
</template>
